/**
 * Build environment — is this bundle a DEV build or a PROD build?
 *
 * Two ways the add-in reaches Word:
 *   - ``pnpm dev`` from addin/ (local Vite dev server, HTTPS on :3000)
 *   - ``docker compose -f docker-compose.prod.yml`` → docker/Dockerfile.addin
 *     runs ``pnpm build`` and serves the static bundle at app.sangnan.ai
 *
 * Vite sets ``import.meta.env.DEV`` to true only under the dev server and
 * false under ``vite build``, which is exactly that split — so no extra env
 * var or manifest edit is needed to tell them apart.
 *
 * The top bar's mode pill reads this to label the build ("DEV" instead of
 * "LIVE") so a writer can see at a glance which stack their task pane is
 * talking to.
 */
export const isDevBuild: boolean = import.meta.env.DEV === true;
